const TOGGLE_DOWN_DISTANCE_COLLAPSE = 'TOGGLE_DOWN_DISTANCE_COLLAPSE';
const SET_DOWN_DISTANCE_POSSIBLE_SELECTIONS = 'SET_DOWN_DISTANCE_POSSIBLE_SELECTIONS';
const SET_DOWN_DISTANCE_SELECTIONS = 'SET_DOWN_DISTANCE_SELECTIONS';
const CLEAR_DOWN_DISTANCE_POSSIBLE_SELECTIONS = 'SET_DOWN_DISTANCE_POSSIBLE_SELECTIONS';
const CLEAR_DOWN_DISTANCE_SELECTIONS = 'CLEAR_DOWN_DISTANCE_SELECTIONS';

const INITIAL_STATE = {
  isCollapsed: false,
  possibleSelections: [],
  selections: {},
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case TOGGLE_DOWN_DISTANCE_COLLAPSE:
      return {
        ...state,
        isCollapsed: !state.isCollapsed,
      };
    case SET_DOWN_DISTANCE_POSSIBLE_SELECTIONS:
      return {
        ...state,
        possibleSelections: [...action.payload],
      };
    case SET_DOWN_DISTANCE_SELECTIONS:
      return {
        ...state,
        selections: { ...action.payload },
      };
    case CLEAR_DOWN_DISTANCE_POSSIBLE_SELECTIONS:
      return {
        ...state,
        possibleSelections: [...action.payload],
      };
    case CLEAR_DOWN_DISTANCE_SELECTIONS:
      return {
        ...state,
        selections: { ...action.payload },
      };
    default:
      return state;
  }
}

export function toggleDownDistanceCollapse() {
  return {
    type: TOGGLE_DOWN_DISTANCE_COLLAPSE,
  };
}

export function setPossibleSelections(possibleSelections) {
  return {
    type: SET_DOWN_DISTANCE_POSSIBLE_SELECTIONS,
    payload: possibleSelections,
  };
}

export function setSelections(selections) {
  return {
    type: SET_DOWN_DISTANCE_SELECTIONS,
    payload: selections,
  };
}

export function clearPossibleSelections() {
  return {
    type: CLEAR_DOWN_DISTANCE_POSSIBLE_SELECTIONS,
    payload: [],
  };
}

export function clearSelections() {
  return {
    type: CLEAR_DOWN_DISTANCE_SELECTIONS,
    payload: {},
  };
}

export function clearDownDistanceSelections() {
  return (dispatch) => {
    dispatch({
      type: CLEAR_DOWN_DISTANCE_POSSIBLE_SELECTIONS,
      payload: [],
    });

    dispatch({
      type: CLEAR_DOWN_DISTANCE_SELECTIONS,
      payload: {},
    });
  };
}
